import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import { HiMenu, HiX } from 'react-icons/hi';
import './Navbar.css';

const NAV_LEFT = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Asset Management', path: '/asset-management' },
];
const NAV_RIGHT = [
  { name: 'Advisory', path: '/advisory' },
  { name: 'Insights', path: '/insights' },
  { name: 'Investor Relations', path: '/investor-relations' },
  { name: 'Contact', path: '/contact' },
];

const Navbar: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  useEffect(() => {
    if (!mobileOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMobileOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [mobileOpen]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="nav" role="navigation" aria-label="Main navigation">
      <Link to="/" className="nav-logo" onClick={() => setMobileOpen(false)}>
        <img src="/assets/logos/kyro-logo-white.png" alt="Kyro - Alternative Investments & Corporate Advisory" className="nav-logo-img" />
      </Link>

      <div className="nav-links nav-links-right">
        {NAV_LEFT.map(({ name, path }) => (
          <Link
            key={path}
            to={path}
            className={`nav-link ${isActive(path) ? 'active' : ''}`}
          >
            {name}
          </Link>
        ))}
        {NAV_RIGHT.map(({ name, path }) => (
          <Link
            key={path}
            to={path}
            className={`nav-link ${isActive(path) ? 'active' : ''}`}
          >
            {name}
          </Link>
        ))}
        <Link to="/investor-login" className="nav-cta">
          Investor Login
        </Link>
      </div>

      <button
        className="nav-menu-btn"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
      >
        {mobileOpen ? <HiX size={24} /> : <HiMenu size={24} />}
      </button>

      {mobileOpen && createPortal(
        <div className="nav-mobile" role="dialog" aria-modal="true" aria-label="Mobile menu">
          <button
            className="nav-mobile-close"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <HiX size={24} />
          </button>
          <div className="nav-mobile-links">
            {[...NAV_LEFT, ...NAV_RIGHT].map(({ name, path }) => (
              <Link
                key={path}
                to={path}
                className="nav-mobile-link"
                onClick={() => setMobileOpen(false)}
              >
                {name}
              </Link>
            ))}
            <Link
              to="/investor-login"
              className="nav-mobile-cta"
              onClick={() => setMobileOpen(false)}
            >
              Investor Login
            </Link>
          </div>
        </div>,
        document.body
      )}
    </nav>
  );
};

export default Navbar;
